import CommonTooltip from 'components/CommonTooltip'
import CertificationIcon from 'assets/images/svg/common/certification.svg'
import { Box, styled, Typography, useTheme } from '@mui/material'

const TooltipContent = styled(Box)`
  padding: 24px;
  text-align: center;
`

const TooltipImg = styled('img')`
  width: 18px !important;
  height: 18px !important;
`

export default function AccountCertification({ name, explain }: { name?: string | null; explain?: string | null }) {
  const theme = useTheme()
  return (
    <>
      {name ? (
        <CommonTooltip
          placement="bottom"
          content={
            <TooltipContent>
              <img src={CertificationIcon} alt="" width="48px" height="48px" />
              <Typography
                marginTop="8px"
                marginBottom="12px"
                fontSize="24px"
                lineHeight="32px"
                fontWeight={700}
                color={theme.colors.white}
              >
                {name}
              </Typography>
              <Typography fontSize="16px" lineHeight="26px" color={theme.colors.primary[100]}>
                {explain}
              </Typography>
            </TooltipContent>
          }
        >
          <TooltipImg
            src={CertificationIcon}
            alt=""
            style={{
              marginLeft: '5px',
            }}
          />
        </CommonTooltip>
      ) : (
        <></>
      )}
    </>
  )
}
